var _jsxFileName = "/repo/packages/webassets/src/components/Footer/FooterLinks/AuthedFooterLinks.tsx",
  _this = this;
import React, { useContext } from 'react';
import { getAuthFooterLinks } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';
import CopyRight from '../CopyRight';
var AuthedFooterLinks = function AuthedFooterLinks(_ref) {
  var _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? 'surveymonkey' : _ref$domain,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? 'en' : _ref$lang;
  var _useContext = useContext(SMFooterContext),
    onetrustBannerEnabled = _useContext.onetrustBannerEnabled;
  var links = getAuthFooterLinks(domain, lang);
  return /*#__PURE__*/React.createElement(InlineList, {
    noMargin: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, links.map(function (item) {
    return /*#__PURE__*/React.createElement(InlineListItem, {
      key: item.title,
      href: item.url,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }
    }, item.title);
  }), /*#__PURE__*/React.createElement(InlineListItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(CopyRight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  })), !!onetrustBannerEnabled ? /*#__PURE__*/React.createElement(InlineListItem, {
    href: "#cookiePreferences",
    className: "ot-sdk-show-settings",
    "data-testid": "AuthedFooterLinks__cookiePreferences",
    lastItem: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }) : null);
};
export default AuthedFooterLinks;
//# sourceMappingURL=AuthedFooterLinks.js.map